import { getMyChecklist } from '@/api/checklist';

let interval;

export default {
  async reloadChecklist({ commit }) {
    clearTimeout(interval);
    setTimeout(async () => {
      try {
        const { data } = await getMyChecklist();
        commit('setChecklist', data);
      } catch (e) {
      }
    }, 3000);
  },
  async loadChecklist({ commit }) {
    try {
      const { data } = await getMyChecklist();
      commit('setChecklist', data);
    } catch (e) {
      console.log(e);
    }
  }
};
